import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { ICity, EmptyCity, IModel } from "./City";
import { Search } from "../../../shared/Search";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setTab: (tab: number) => void
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICity>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'city_Name',
        sortOrder: -1
    });

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("City_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<ICity> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }
    const getTableDataCount = async () => {
        const response = await Fetch("City_Mast/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyCity });
    };

    const openEdit = (rowDatauser: ICity) => {
        rowDatauser.state = { state_ID: rowDatauser.state_ID, state_Name: rowDatauser.state_Name };
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                <Button disabled={tableData.loading} label="Country" className="p-button-secondary mr-2" onClick={() => props.setTab(1)} />
                <Button disabled={tableData.loading} label="State" className="p-button-secondary mr-2" onClick={() => props.setTab(2)} />
                <Button disabled={tableData.loading} label="City" className="p-button-info mr-2" onClick={() => props.setTab(3)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Cities</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: ICity) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="city_Name" header="City Name" sortable />
                <Column field="state_Name" header="State" sortable />
                <Column field="country_Name" header="Country" />
                <Column field="description" header="Description" />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
